<!-- 選擇區塊 -->
<ng-template #Modal let-data let-ref="dialogRef">
    <nb-card class="staffInfoTemplate">
      <nb-card-header>
        選擇門市
      </nb-card-header>
      <nb-card-body>
  
        <div class="mt-3">
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>門市</th>
                <th>啟用</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let e of mainDataList ">
                <tr>
                  <td> {{ e.storeName }}</td>
                  <td>
                    <nb-toggle status="info" [(checked)]="e.isChecked" 
                      (checkedChange)="onSelect($event, e)">
                    </nb-toggle>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </nb-card-body>
      <nb-card-footer>
        <button nbButton (click)="onSave();">確定</button>
        <button nbButton (click)="ref.close()">取消</button>
      </nb-card-footer>
    </nb-card>
  </ng-template>